<router-outlet *ngIf="!isIframe"></router-outlet>
<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="ball-pulse" [fullScreen]="true"></ngx-spinner>
